import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {MenuItem} from "../model/menuItem";
import {Menu} from "../model/menu";
import {CmsPage} from "../../page/model/page";
import {Observable, of} from "rxjs";
import {catchError, debounceTime, map, startWith, switchMap} from "rxjs/operators";
import {PageService} from "../../page/service/page.service";
import {Pages} from "../../page/model/pages";


@Component({
    selector: 'create-menu-item-dialog',
    templateUrl: './createMenuItemDialog.component.html',
    styleUrls: ['./createMenuItemDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class CreateMenuItemDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    form: FormGroup;
    menuItem: MenuItem;
    menu: Menu;
    filteredPages: Observable<CmsPage[]>;

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<CreateMenuItemDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private _formBuilder: FormBuilder,
        private pageService: PageService,
    ) {
        this.translationLoader.loadTranslations(polish);

        if (!_data.currentItem) {
            this.menuItem = new MenuItem();
            if (_data.parentItem) {
                this.menuItem.parent = _data.parentItem;
            }
        } else {
            this.menuItem = _data.currentItem;
            if (_data.currentItem.parent) {
                this.menuItem.parent = _data.currentItem.parent;
            }
        }

        this.menu = _data.menu;

        this.form = this.createForm();

        this.pageService.getAll(0,20).subscribe((pages: Pages)=>{
            this.filteredPages = this.form.get('page').valueChanges
                .pipe(
                    startWith(''),
                    debounceTime(300),
                    switchMap(value => {
                        if (value !== '') {
                            return this.lookup(value);
                        } else {
                            return of(null);
                        }
                    })
                );
        }, error => {

        });
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.menuItem.id],
            name: [this.menuItem.name, Validators.required],
            page: [this.menuItem.page, Validators.required],
            tagTitle: [this.menuItem.tagTitle],
            order: [this.menuItem.order],
            parent: [this.menuItem.parent],
        });
    }

    displayFn(page: CmsPage): string {
        return (page)? page.languages[0].name: '';
    }

    lookup(value: string): Observable<CmsPage[]> {
        // console.log(value);
        return this.pageService.getAll(0,20).pipe(
            // map the item property of the github results as our return object
            map(results => results.items),
            // catch errors
            catchError(_ => {
                return of(null);
            })
        );
    }
}
